import { Button } from '@tunein/react-ui';
import { useContext, useState } from 'react';
import { CLEAR_ALL_RECENTS_BUTTON } from 'src/common/constants/localizations/settings';
import { LocationAndLocalizationContext } from '../../../../providers/LocationAndLocalizationProvider';
import { ClearAllRecentsForm } from '../../../clearAllRecents/ClearAllRecentsForm';
import settingsCss from '../../../settings/account-settings.module.scss';
import CommonDialog from '../../../shared/dialog/CommonDialog';
import css from './container-actions.module.scss';

/**
 * Container-level "clear all recents" action. Rendered purely off the container's
 * `actions.clearAllRecents`, so the API alone decides whether it's offered — there's no
 * client-side gate to keep in sync.
 */
export function ClearAllRecentsAction() {
  const { getLocalizedText } = useContext(LocationAndLocalizationContext);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const closeDialog = () => setIsDialogOpen(false);

  return (
    <>
      <Button
        className={css.actionButton}
        data-testid="clearAllRecentsContainerAction"
        onClick={() => setIsDialogOpen(true)}
        radius="full"
        variant="outlined"
      >
        {getLocalizedText(CLEAR_ALL_RECENTS_BUTTON)}
      </Button>
      <CommonDialog
        data-testid="clearAllRecentsContainerDialog"
        dialogOpen={isDialogOpen}
        handleDialogClose={closeDialog}
        classNames={{
          body: settingsCss.dialogBody,
          content: settingsCss.dialogContent,
        }}
        closeButtonProps={{ className: settingsCss.closeIcon }}
        preventOverlayClose
      >
        <ClearAllRecentsForm handleClose={closeDialog} />
      </CommonDialog>
    </>
  );
}
